import React from "react";
import Container from "react-bootstrap/Container";
import Jumbotron from "react-bootstrap/Jumbotron";

const Contact = ({ heading, message, email, discord }) => {
	return (
		<Jumbotron fluid id="contact" className="m-0">
			<Container className="text-center">
				<h2 className="display-4 pb-5 text-center">{heading}</h2>
                <p className="lead">{message}</p>
                <p>Email: <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer">{email}</a></p>
                <p>Discord: <a href="https://discord.com/users/453103897012338688" target="_blank" rel="noopener noreferrer">{discord}</a></p>
			</Container>
		</Jumbotron>
	);
};

export default Contact;